// KVMetricsTracker.ts
export interface KVMetrics {
    get: number;
    set: number;
    del: number;
    scan: number;
    zadd: number;
    zrem: number;
    zrange: number;
    zrangeByScore: number;
    zremrangebyscore: number;
    zrangeByLex: number;
    totalCalls: number;
    lastCall: {
        operation: string;
        key: string;
        timestamp: number;
    };
}

export class KVMetricsTracker {
    protected metrics: KVMetrics = {
        get: 0,
        set: 0,
        del: 0,
        scan: 0,
        zadd: 0,
        zrem: 0,
        zrange: 0,
        zrangeByScore: 0,
        zrangeByLex: 0,
        zremrangebyscore: 0,
        totalCalls: 0,
        lastCall: {
            operation: '',
            key: '',
            timestamp: 0
        }
    };

    public getMetrics(): KVMetrics {
        return { ...this.metrics };
    }

    protected trackOperation(operation: keyof KVMetrics, key: string): void {
        this.metrics[operation]++;
        this.metrics.totalCalls++;
        this.metrics.lastCall = {
            operation,
            key,
            timestamp: Date.now()
        };
    }
}